import { useQuery } from "@tanstack/react-query";
import type { DesktopReleaseFeed } from "@forma/shared";
import { api } from "./api";
export function useDesktopReleases() {
  return useQuery({
    queryKey: ["releases"],
    queryFn: () => api<DesktopReleaseFeed>("GET", "/releases"),
    staleTime: 60_000,
    refetchInterval: 15 * 60_000,
  });
}
